<template>
  <div class="no-print">
    <v-expansion-panels
      v-if="appointmentQuestionnaires.length"
      :value="needsToBringPanelOpened(appointmentQuestionnaires.length)"
      accordion
      multiple
    >
      <v-expansion-panel
        v-for="questionnaire in appointmentQuestionnaires"
        :key="questionnaire.id"
        v-model="panel"
      >
        <v-expansion-panel-header class="grey lighten-5">
          <v-row no-gutters>
            <v-col cols="12" sm="7">
              <h3 class="pt-2">
                {{ $t(questionnaire.name) }}
              </h3>
            </v-col>
            <v-col cols="12" sm="5" class="pr-5 text-right">
              <small class="overline grey--text transparent">
                {{ formatDate(questionnaire.date_created) }}
              </small>
            </v-col>
          </v-row>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <v-divider class="mb-6" />
          <ol>
            <li
              v-for="question in questionnaire.questions"
              :key="question.id"
              no-gutters
            >
              <h4>
                {{ question.label }}
              </h4>
              <div v-if="question.answer">
                <p v-if="question.type !== 'FILE'">
                  {{ handleAnswer(question) }}
                </p>
                <v-chip
                  v-else
                  :key="question.answer.file_value.id"
                  @click="openFile(question.answer.id)"
                  color="grey lighten-3"
                  class="mt-2 px-3"
                  target="_blank"
                >
                  <strong>{{ question.answer.file_value.name }}</strong>
                  <v-icon color="primary" class="ml-1" small>
                    mdi-open-in-new
                  </v-icon>
                </v-chip>
              </div>
              <span v-else>
                ---
              </span>
            </li>
          </ol>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div v-else class="d-flex justify-center white lighten-3 pa-5 grey--text">
      {{ $t('emptyState.noData') }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getDownloadFileAnswerUrl } from '@/services/questionnaire/questionnaireService'
import { catalogDate } from '@/util/catalog'

export default {
  name: 'ScreenOnlyQuestionnaire',

  data: () => {
    return {
      panel: '',
      fileDownloadUrl: getDownloadFileAnswerUrl
    }
  },

  props: {
    isAdmin: {
      type: Boolean,
      default: false,
      required: false,
    }
  },

  computed: {
    ...mapGetters(['appointmentQuestionnaires']),
  },

  methods: {
    formatDate(date) {
      return catalogDate(date)
    },

    handleAnswer(question) {
      let answer = question.answer
      switch (question.type) {
        case 'BOOLEAN':
          return this.$t(`boolean.${answer.bool_value}`)
        case 'NUMERIC':
          return answer.numeric_value
        case 'ENUM':
          return answer.enum_value
        case 'TEXT':
          return answer.text_value
        default:
          return null
      }
    },

    needsToBringPanelOpened(length) {
      return length > 1 ? [] : [0]
    },

    async openFile(answerId) {
      await this.fileDownloadUrl(answerId, this.isAdmin)
      .then(({data}) => {
        window.open(data.url, '_blank')
      })
    }
  },
}
</script>

<style scoped>
@media print {
  .no-print {
    display: none;
  }
}
</style>
